class AvatarVideo extends HTMLElement {
  /** @type {AbortController} */
  #controller = new AbortController();

  /** @type {HTMLVideoElement | null} */
  #video = null;

  /** @type {HTMLButtonElement | null} */
  #playBtn = null;

  /** @type {HTMLButtonElement | null} */
  #muteBtn = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.#video = this.querySelector('video');
    if (!this.#video) return; 

    this.#playBtn = this.querySelector('[data-action="playpause"]');
    this.#muteBtn = this.querySelector('[data-action="mute"]');

    this.#playBtn?.addEventListener(
      'click',
      () => {
        const video = this.#video;
        if (!video) return;
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { signal }
    );

    this.#muteBtn?.addEventListener(
      'click',
      () => {
        if (this.#video) this.#video.muted = !this.#video.muted;
      },
      { signal }
    );

    this.#video.addEventListener('play', () => this.#syncPlay(), { signal });
    this.#video.addEventListener('pause', () => this.#syncPlay(), { signal });
    this.#video.addEventListener('volumechange', () => this.#syncMute(), { signal });

    this.#syncPlay();
    this.#syncMute();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #syncPlay() {
    if (!this.#video) return;
    const playing = !this.#video.paused;
    this.#swap(
      this.#playBtn,
      '.support-avatar-video__icon--pause',
      '.support-avatar-video__icon--play',
      playing
    );
    this.#playBtn?.setAttribute(
      'aria-label',
      (playing ? this.dataset.labelPause : this.dataset.labelPlay) ?? ''
    );
  }

  #syncMute() {
    if (!this.#video) return;
    const muted = this.#video.muted;
    this.#swap(
      this.#muteBtn,
      '.support-avatar-video__icon--mute',
      '.support-avatar-video__icon--unmute',
      muted
    );
    this.#muteBtn?.setAttribute(
      'aria-label',
      (muted ? this.dataset.labelUnmute : this.dataset.labelMute) ?? ''
    );
  }

  /**
   * Show `selA`, hide `selB` when `showFirst` is true; reverse otherwise.
   * @param {HTMLButtonElement | null} btn
   * @param {string} selA
   * @param {string} selB
   * @param {boolean} showFirst
   */
  #swap(btn, selA, selB, showFirst) {
    if (!btn) return;
    btn.querySelector(selA)?.toggleAttribute('hidden', !showFirst);
    btn.querySelector(selB)?.toggleAttribute('hidden', showFirst);
  }
}

if (!customElements.get('avatar-video')) {
  customElements.define('avatar-video', AvatarVideo);
}
